import React, { useState, useEffect, useCallback, useContext } from 'react';
import RoomContext from '../RoomContext';
import { useRoomApi } from '../hooks/useRoomApi';
import RoomConfigForm from './RoomConfigForm';
import ScheduleEditor from './ScheduleEditor';
import DeviceManager from './DeviceManager';

// Admin screens for one room: control config, per-activity target temperatures, and device/calibration
// management. Loads the room config once to obtain its numeric id (needed to assign devices to this room).
const ConfigurationTab = () => {
  const { tenant, room } = useContext(RoomContext);
  const api = useRoomApi(tenant, room);
  const [config, setConfig] = useState(null);
  const [error, setError] = useState(null);

  const loadConfig = useCallback(async () => {
    try {
      setConfig(await api.getConfig());
      setError(null);
    } catch (e) {
      setError('No se pudo cargar la configuración.');
    }
  }, [api]);

  useEffect(() => { loadConfig(); }, [loadConfig]);

  if (error && !config) return <div className="alert alert-danger mt-3">{error}</div>;
  if (!config) return <div className="p-3">Cargando…</div>;

  return (
    <div className="pt-3">
      <Section title="Ajustes de la sala">
        <RoomConfigForm config={config} onSaved={loadConfig} />
      </Section>
      <Section title="Programación">
        <ScheduleEditor />
      </Section>
      <Section title="Dispositivos">
        <DeviceManager roomId={config.roomId} />
      </Section>
    </div>
  );
};

const Section = ({ title, children }) => (
  <div className="card mb-3">
    <div className="card-header fw-semibold">{title}</div>
    <div className="card-body">{children}</div>
  </div>
);

export default ConfigurationTab;
